import UltMeta, { Meta } from "./UltMeta/index";

class SupervisionType extends UltMeta {
    WAREHOUSE = new Meta(1, "仓库");
    PROJECT = new Meta(2, "项目");
}

export const SUPERVISION_TYPE = new SupervisionType();
